import React from "react";

const DivideLine = () => {
    return <hr className={"DivideLine w-full h-[2px] bg-black bg-opacity-30 shadow-none my-1"} />;
};

export default DivideLine;
